import { render } from "./RegistrationForm.vue?vue&type=template&id=d73bb428&scoped=true&bindings={\"showForm\":\"data\",\"wasValidated\":\"data\",\"firstName\":\"data\",\"lastName\":\"data\",\"organization\":\"data\",\"email\":\"data\",\"password\":\"data\",\"passwordAgain\":\"data\",\"postRegistration\":\"options\"}"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"

import "./RegistrationForm.vue?vue&type=style&index=0&id=d73bb428&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d73bb428"

export default script